import { StaticCost } from "./StaticCost"

/**
 *
 */
export const StaticCostLabel: Record<StaticCost, string> = {
  [StaticCost.NORMAL]: "Normal Strategy",
  [StaticCost.STATIC]: "Static Peak",
}